import { gql } from "@apollo/client";

export const UPDATE_FEEDBACK_STATUS = gql`
  mutation updateFeedbackStatus($id: Int!, $status: String!) {
    updateFeedbackStatus(id: $id, status: $status) {
      id
    }
  }
`;